// ===== 記事末尾の「関連コンテンツ」定義 =====
// 記事ページの末尾に自動で付く「関連ツール」「あわせて読みたい」の対応表。
// 記事本体のファイルは触らず、ここに1行追加するだけで導線が増える。
//
// RELATED_TOOLS: 記事ID → ツールID（src/data/toolsData.js の id）の配列
// RELATED_ARTICLES: 記事ID → 記事ID の配列（最大3件表示。未登録の記事は同じカテゴリ内の並び順から自動で補う）

export const RELATED_TOOLS = {
  article_news_score: [7],
  article_fever_response: [7],
  article_blood_pressure_response: [7],
  article_pulse_assessment: [7],
  article_spo2_assessment: [8, 7],
  article_fio2_conversion: [8],
  article_consciousness_level: [4],
  article_design_r: [2, 14],
  article_pressure_ulcer_care: [2, 14],
  article_braden_scale: [3],
  article_wound_observation: [15],
  article_hdsr: [9, 10],
  article_delirium_assessment: [12, 16],
  article_insomnia_response: [12, 16],
  article_mna_sf: [11],
  article_nasogastric_feeding: [11],
  article_balloon_catheter: [5],
  article_dehydration: [5],
  article_massho_jomyakuro: [1],
  article_disinfectant_dilution: [13],
  article_hand_hygiene: [13],
};

export const RELATED_ARTICLES = {
  // バイタルサイン（測定 ⇔ 評価・対応 を行き来できるように）
  article_temperature_measurement: ['article_fever_response', 'article_pulse_measurement', 'article_blood_pressure_measurement'],
  article_pulse_measurement: ['article_pulse_assessment', 'article_blood_pressure_measurement', 'article_temperature_measurement'],
  article_blood_pressure_measurement: ['article_blood_pressure_response', 'article_pulse_measurement', 'article_temperature_measurement'],
  article_fever_response: ['article_news_score', 'article_temperature_measurement', 'article_sbar_reporting'],
  article_blood_pressure_response: ['article_blood_pressure_measurement', 'article_pulse_assessment', 'article_news_score'],
  article_pulse_assessment: ['article_pulse_measurement', 'article_blood_pressure_response', 'article_12_lead_ecg'],
  article_spo2_assessment: ['article_fio2_conversion', 'article_lung_sounds', 'article_news_score'],
  article_news_score: ['article_fever_response', 'article_spo2_assessment', 'article_sbar_reporting'],
  article_fio2_conversion: ['article_spo2_assessment', 'article_lung_sounds', 'article_news_score'],
  article_lung_sounds: ['article_spo2_assessment', 'article_suctioning', 'article_fio2_conversion'],
  article_12_lead_ecg: ['article_pulse_assessment', 'article_pulse_measurement', 'article_sbar_reporting'],
  article_consciousness_level: ['article_news_score', 'article_delirium_assessment', 'article_hdsr'],

  // 褥瘡・創傷・皮膚
  article_design_r: ['article_pressure_ulcer_care', 'article_braden_scale', 'article_wound_observation'],
  article_braden_scale: ['article_design_r', 'article_pressure_ulcer_care', 'article_mna_sf'],
  article_pressure_ulcer_care: ['article_design_r', 'article_braden_scale', 'article_wound_observation'],
  article_wound_observation: ['article_pressure_ulcer_care', 'article_design_r', 'article_hisshin'],
  article_hisshin: ['article_wound_observation', 'article_sbar_reporting', 'article_soap'],
  article_peripheral_circulation: ['article_edema', 'article_blood_pressure_response', 'article_sbar_reporting'],
  article_edema: ['article_peripheral_circulation', 'article_dehydration', 'article_wound_observation'],
  article_ingrown_toenail: ['article_hisshin', 'article_eye_drops', 'article_behavioral_economics_patient'],

  // 認知・せん妄・不眠
  article_hdsr: ['article_delirium_assessment', 'article_consciousness_level', 'article_behavioral_economics_patient'],
  article_delirium_assessment: ['article_insomnia_response', 'article_hdsr', 'article_consciousness_level'],
  article_insomnia_response: ['article_delirium_assessment', 'article_sbar_reporting', 'article_cbt_patient'],

  // 栄養・水分・排泄
  article_mna_sf: ['article_braden_scale', 'article_dehydration', 'article_nasogastric_feeding'],
  article_dehydration: ['article_anemia', 'article_edema', 'article_mna_sf'],
  article_anemia: ['article_dehydration', 'article_spo2_assessment', 'article_peripheral_circulation'],
  article_toromi: ['article_nasogastric_feeding', 'article_dehydration', 'article_suctioning'],
  article_nasogastric_feeding: ['article_toromi', 'article_suctioning', 'article_mna_sf'],
  article_suctioning: ['article_lung_sounds', 'article_nasogastric_feeding', 'article_hand_hygiene'],
  article_constipation_assessment: ['article_enema', 'article_manual_evacuation', 'article_dehydration'],
  article_enema: ['article_manual_evacuation', 'article_constipation_assessment', 'article_dounyou'],
  article_manual_evacuation: ['article_enema', 'article_constipation_assessment', 'article_dounyou'],
  article_dounyou: ['article_balloon_catheter', 'article_massho_jomyakuro', 'article_hand_hygiene'],
  article_balloon_catheter: ['article_dounyou', 'article_dehydration', 'article_hand_hygiene'],

  // 穿刺・感染対策
  article_blood_collection: ['article_massho_jomyakuro', 'article_anemia', 'article_hand_hygiene'],
  article_massho_jomyakuro: ['article_blood_collection', 'article_dehydration', 'article_hand_hygiene'],
  article_hand_hygiene: ['article_disinfectant_dilution', 'article_balloon_catheter', 'article_behavioral_economics_patient'],
  article_disinfectant_dilution: ['article_hand_hygiene', 'article_suctioning', 'article_balloon_catheter'],
  article_eye_drops: ['article_behavioral_economics_patient', 'article_ingrown_toenail', 'article_mi_basics'],

  // 報告・記録・コミュニケーション
  article_pain_scale: ['article_sbar_reporting', 'article_soap', 'article_cbt_patient'],
  article_soap: ['article_sbar_reporting', 'article_critical_thinking_basics', 'article_staff_communication_basics'],
  article_sbar_reporting: ['article_soap', 'article_assertion_basics', 'article_news_score'],
  article_staff_communication_basics: ['article_sbar_reporting', 'article_assertion_basics', 'article_critical_thinking_basics'],
  article_critical_thinking_basics: ['article_soap', 'article_staff_communication_basics', 'article_behavioral_economics_patient'],
  article_assertion_basics: ['article_sbar_reporting', 'article_staff_communication_basics', 'article_mi_basics'],
  article_mi_basics: ['article_cbt_patient', 'article_behavioral_economics_patient', 'article_assertion_basics'],
  article_cbt_patient: ['article_mi_basics', 'article_behavioral_economics_patient', 'article_insomnia_response'],
  article_behavioral_economics_patient: ['article_mi_basics', 'article_cbt_patient', 'article_hand_hygiene'],
};
